import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

import { computed } from 'vue';
import { localeOptions, setLocale, getLocale } from '@/i18n'

export default /*#__PURE__*/_defineComponent({
  __name: 'lang-toggle',
  props: {
  showLabel: {
    type: Boolean,
    default: false
  },
  size: {
    type: String,
    default: false
  }
},
  setup(__props) {

const props = __props
const btnSize = {
  small: 'btn_tool-small',
  default: 'btn_tool-default'
}[props.size||'small']
const currentLocale = computed(() => getLocale())
function handleLocaleChange(locale: string) {
  setLocale(locale as 'zh-CN' | 'zh-TW' | 'en-US' | 'ja-JP')
}

return (_ctx: any,_cache: any) => {
  const _component_CmSvgIcon = _resolveComponent("CmSvgIcon")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!

  return (_openBlock(), _createBlock(_component_el_dropdown, {
    class: "locale-dropdown",
    "popper-class": "theme-dropdown-popper",
    size: "small",
    trigger: "click",
    onCommand: handleLocaleChange
  }, {
    dropdown: _withCtx(() => [
      _createVNode(_component_el_dropdown_menu, null, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(localeOptions), (opt) => {
            return (_openBlock(), _createBlock(_component_el_dropdown_item, {
              key: opt.value,
              command: opt.value,
              class: _normalizeClass({ 'is-active': currentLocale.value === opt.value })
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(opt.label), 1)
              ]),
              _: 2
            }, 1032, ["command", "class"]))
          }), 128))
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(["locale-trigger btn_tool", [{ 'has-label': __props.showLabel },_unref(btnSize)]])
      }, [
        _createVNode(_component_CmSvgIcon, {
          name: "assets/icons/lang",
          class: "locale-icon",
          monochrome: "",
          size: 20,
          "aria-hidden": false,
          "aria-label": "language"
        })
      ], 2)
    ]),
    _: 1
  }))
}
}

})